export default __webpack_public_path__ + "static/media/16.4b14d699.jpg";